if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('no-inert') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header site-header'

				if ( this.classList.contains('site-header--style-one-row') ) {

					stickyHeader.innerHTML = `<div class="container--large">
						<div class="${this.querySelector('.header__top').className }" style="height:calc(var(--header-logo) + var(--header-vertical-space))">
							${this.querySelector('.header__top').innerHTML}
						</div>
					</div>`;
					stickyHeader.className = `sticky-header ${this.className}`;
					stickyHeader.classList.remove('site-header--absolute');

				} else {

					stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
						${this.querySelector('.header__bottom').innerHTML}
						<div style="display:flex;gap:15px;">
							${this.querySelector('.area--custom-icon') ? this.querySelector('.area--custom-icon').outerHTML : ''}
							${this.querySelector('.area--search').outerHTML}
							${this.querySelector('.area--account') ? this.querySelector('.area--account').outerHTML : ''}
							${this.querySelector('.area--cart').outerHTML}
						</div>
					</div>
					<div class="site-header element--hide-on-portable-plus">
						${this.querySelector('.header-container--top').innerHTML}
					</div>`;
					
				}
			
				document.body.append(stickyHeader);
				
				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('.site-nav [aria-controls]').forEach(elm=>{
					elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
				});

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound =  this.classList.contains('site-header--style-one-row') ? this.querySelector('.header__top') : this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				const syncStickyHeaderOffset = () => {
					document.documentElement.style.setProperty('--sticky-header-offset', stickyHeader.classList.contains('show') ? `${stickyHeader.offsetHeight}px` : '0px');
				}

				this.SCROLL_StickyHelper = () => {

					var st = window.scrollY;

					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						stickyHeader.classList.remove('show');
						syncStickyHeaderOffset();
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							stickyHeader.classList.remove('show');

						} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							stickyHeader.classList.add('show');

						} else if ( st > lst && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
						}

						syncStickyHeaderOffset();

					}

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});
				
			}

			// drawer connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						if ( elm.hasAttribute('data-js-sidebar-handle-direction') ) {
							elmSidebar.classList.remove('sidebar--left', 'sidebar--right');
							elmSidebar.classList.add(`sidebar--${elm.getAttribute('data-js-sidebar-handle-direction')}`);
						}
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							if ( elm.hasAttribute('data-js-sidebar-handle-direction') ) {
								elmSidebar.classList.remove('sidebar--left', 'sidebar--right');
								elmSidebar.classList.add(`sidebar--${elm.getAttribute('data-js-sidebar-handle-direction')}`);
							}
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			});
			if ( this.classList.contains('site-header--alignment-left') || this.classList.contains('site-header--style-one-row') ) {
				document.getElementById('site-search-sidebar').classList.remove('sidebar--left');
				document.getElementById('site-search-sidebar').classList.add('sidebar--right');
			}
			if ( this.classList.contains('site-header--style-one-row') && this.classList.contains('site-header--alignment-center') ) {
				document.getElementById('site-menu-sidebar').classList.remove('sidebar--right');
				document.getElementById('site-menu-sidebar').classList.add('sidebar--left');
			}
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			this.KEYDOWN_EscHelper = e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			};
			document.addEventListener('keydown', this.KEYDOWN_EscHelper);

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
					--window-width: ${document.body.clientWidth}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
			}`;
			document.body.classList.add('header-loaded');

			// The desktop menu no longer collapses to the burger when space is tight - the
			// redesigned header always shows dropdowns from 1024px and the burger below
			// (component-nav-redesign.css), so the old width check is gone.

			// submenu masonry

			document.querySelectorAll('.site-nav.style--classic .submenu-masonry').forEach(elm=>{
				const columns = parseInt(elm.getAttribute('data-columns')) || 1;
				const trigger = elm.closest('.has-submenu');
				if ( ! trigger ) return;
				// Build MiniMasonry on first open (relayout on later opens) inside rAF, once the
				// menu is visible — measuring a hidden menu produced inconsistent column gaps.
				let masonry = null;
				const layoutMasonry = () => requestAnimationFrame(() => {
					if ( typeof MiniMasonry === 'undefined' ) return;
					const width = elm.clientWidth;
					if ( ! width ) return;
					// Read the gutter from the CSS grid-gap so it stays the single source of truth:
					// once items become position:absolute the grid-gap no longer applies, so we feed
					// the same value to MiniMasonry. Measured before masonry-active swaps display to block.
					const styles = getComputedStyle(elm);
					const gutter = parseFloat(styles.columnGap) || 0;
					const gutterY = parseFloat(styles.rowGap) || gutter;
					if ( masonry ) masonry.destroy();
					elm.classList.add('masonry-active');
					masonry = new MiniMasonry({
						container: elm,
						baseWidth: Math.floor((width + gutter) / columns) - gutter,
						gutterX: gutter,
						gutterY: gutterY,
						ultimateGutter: gutterY,
						surroundingGutter: false,
						direction: document.documentElement.getAttribute('dir') === 'rtl' ? 'rtl' : 'ltr'
					});
					elm.querySelectorAll('img').forEach(img => {
						if ( ! img.complete ) {
							img.addEventListener('load', () => { if ( masonry ) masonry.layout(); }, { once: true });
						}
					});
				});
				trigger.addEventListener('mouseenter', layoutMasonry);
				trigger.addEventListener('focusin', layoutMasonry);
			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

				// predictive search (sidebar)

				document.querySelectorAll('[data-js-open-search-drawer]').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
						setTimeout(()=>{
							document.querySelector('#search-form-sidebar').focus();
						}, 10)
					});
				});

			} else {

				this.querySelector('search-form').addEventListener('click', e=>{
					e.preventDefault();
					window.location.href = KROWN.settings.routes.search_url;
				});

			}

			// touch menu helpers

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			if ( 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ) {
				document.querySelectorAll('.style--classic .has-babymenu > a').forEach(elmLink=>{
					const elm = elmLink.parentElement;
					elmLink.addEventListener('click', e=>{
						e.preventDefault();
						e.stopPropagation();
						elm.classList.toggle('focus');
						babyMenuTouch = true;
						closeTouchSubmenus(elm,elm.closest('.has-submenu'));
					})
				})
				document.querySelectorAll('.style--classic .has-submenu > a').forEach(elmLink=>{
					const elm = elmLink.parentElement;
					if ( ! elm.classList.contains('mega-link') ) {
						elmLink.addEventListener('click', e=>{
							e.preventDefault();
							e.stopPropagation();
							if ( ! babyMenuTouch ) {
								elm.classList.toggle('focus');
								closeTouchSubmenus(elm);
							}
							babyMenuTouch = false;
						})
					}
				});
			}

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'true');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
			window.removeEventListener('scroll', this.SCROLL_StickyHelper);
			if ( this.KEYDOWN_EscHelper ) {
				document.removeEventListener('keydown', this.KEYDOWN_EscHelper);
			}
			document.querySelector('.sticky-header')?.remove();
		}

		disconnectedCallback(){
			this.unmount();
		}


		_adjustNavLayout() {
			if ( this.querySelector('.site-nav') && this.querySelector('.site-nav').classList.contains('style--classic') ) {

				if ( this.querySelector('nav > ul').scrollWidth > this.querySelector('nav').offsetWidth ) {
					this.classList.add('site-header--swap-menu-style');
					document.body.classList.remove('header--has-two-rows');
					let header = document.getElementById('site-header');
					let twoRowsDetected = header.querySelectorAll('[class*="two-rows"]');
					twoRowsDetected.forEach(el=>{
						el.className = el.className.replace('two-rows', 'one-row');
					});
				}
			}
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelectorAll('[data-js-close]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this.hide();
				});
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			this._opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			if ( this.id == 'site-cart-sidebar' && document.getElementById('cart-recommendations-sidebar') ) {
				setTimeout(()=>{
					document.querySelector('#cart-recommendations-sidebar css-slider')?.resetSlider();
				}, 10);
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				if ( window.inertElems ) {
					window.inertElems.forEach(elm=>{
						elm.setAttribute('inert', '');
					})
				}
			}, 15);

		}

		hide(){

			this._opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			if ( window.inertElems ) {
				window.inertElems.forEach(elm=>{
					elm.removeAttribute('inert');
				})
			}

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this.#resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this.#resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this.#resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this.#resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

		}

		#resizeContainer(main=false){
			if ( this._panelObserver ) this._panelObserver.disconnect();
			if ( main ) {
				this.style.height = `auto`;
			} else {
				let panel = null;
				if ( this._openedSecondSubmenu ) {
					panel = this.querySelector('.has-babymenu.opened .babymenu');
				} else if ( this._openedFirstSubmenu ) {
					panel = this.querySelector('.has-submenu.opened .submenu');
				}
				if ( ! panel ) return;
				this.style.height = `${panel.scrollHeight}px`;
				// Panels with thumbnails keep growing after they open (images and fonts
				// loading in), so keep the height in step - otherwise the bottom is cut
				// off and the drawer can't scroll to it.
				if ( typeof ResizeObserver !== 'undefined' ) {
					this._panelObserver = this._panelObserver || new ResizeObserver(entries => {
						this.style.height = `${entries[0].target.scrollHeight}px`;
					});
					this._panelObserver.observe(panel);
				}
			}
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}